import {getAll, getSubstanceList} from "@core/domain/substance/provider";
import SubstanceList from "@core/domain/substance/SubstanceList";
import {ProductCategorySelect} from "@core/components/product";
import {
    getConcentrationRanges,
    isRangeAboveCoveredWeight,
    resolveConcentrationRange,
    resolveCoveredWeight,
} from './concentration-range'

const ProductPropertyType = {
    MIXTURE_CATEGORY: 'mixture_category',
    MATERIAL_CATEGORY: 'material_category',
    ADDITIONAL_MATERIAL: 'additional_material',
    MAX_CONCENTRATION: 'max_concentration',
    MAX_CONCENTRATION_RANGE: 'max_concentration_range',
    EXEMPTION: 'exemption',
    PRODUCT_CATEGORY: 'product_category',
    GENERAL_PRODUCT_STATEMENTS: 'general_product_statements',

    substanceProperties() {
        return [
            this.MIXTURE_CATEGORY,
            this.MATERIAL_CATEGORY,
            this.ADDITIONAL_MATERIAL,
            this.MAX_CONCENTRATION,
            this.MAX_CONCENTRATION_RANGE,
            this.EXEMPTION,
        ]
    }
};

function getProductPropertyDefaultValue(property) {
    switch (property) {
        case ProductPropertyType.MAX_CONCENTRATION_RANGE:
        case ProductPropertyType.MAX_CONCENTRATION:
            return null;

        case ProductPropertyType.EXEMPTION:
        case ProductPropertyType.ADDITIONAL_MATERIAL:
        case ProductPropertyType.MATERIAL_CATEGORY:
        case ProductPropertyType.MIXTURE_CATEGORY:
            return [];

        default:
            return null;
    }
}

const RegulatedPropertyType = {
    MIXTURE_CATEGORY: 'MIXTURE_CATEGORY',
    MATERIAL_CATEGORY: 'MATERIAL_CATEGORY',
    PRODUCT_CATEGORY: 'PRODUCT_CATEGORY',
    GENERAL_PRODUCT_STATEMENTS: 'GENERAL_PRODUCT_STATEMENTS',

    all() {
        return [
            this.MIXTURE_CATEGORY,
            this.MATERIAL_CATEGORY,
            this.PRODUCT_CATEGORY,
            this.GENERAL_PRODUCT_STATEMENTS,
        ];
    },

    selectorComponentMap() {
        const map = {};
        map[this.MIXTURE_CATEGORY] = 'MixtureCategorySelector';
        map[this.MATERIAL_CATEGORY] = 'MaterialCategorySelector';
        map[this.PRODUCT_CATEGORY] = 'ProductCategorySelector';
        map[this.GENERAL_PRODUCT_STATEMENTS] = 'GeneralProductStatementSelect';
        return map;
    },

    propertyInformation() {
        return [
            {
                property: this.MIXTURE_CATEGORY,
                description: 'Link mixture categories'
            },
            {
                property: this.MATERIAL_CATEGORY,
                description: 'Link material categories'
            },
            {
                property: this.PRODUCT_CATEGORY,
                description: 'Link Product categories'
            },
            {
                property: this.GENERAL_PRODUCT_STATEMENTS,
                description: 'Link General product statements'
            },
        ];
    },

    getTitle(property) {
        return 'Component(RegulatedPropertyType):' + property.toLowerCase();
    }
};


export {
    getAll as getAllSubstanceLists,
    getSubstanceList,
    SubstanceList as SubstanceListClass,
    RegulatedPropertyType,
    ProductPropertyType,
    getProductPropertyDefaultValue,
    getConcentrationRanges,
    isRangeAboveCoveredWeight,
    resolveConcentrationRange,
    resolveCoveredWeight,
};
